export enum CheckoutSteps {
  DeliveryAddress = 0,
  SecureCheckout = 1
}
